import React from "react";
import { trackings } from "../../utils/order";
import { generateStatusStyle } from "../../portals/customer/pages/orders/order_tracking/generateStatus";
import styles from "../styles/authStyles.module.css"
import useWindowWidth from "../../hooks/useWindowWidth";
import useWindowHeight from "../../hooks/useWindowHeight";

export default function OrderTrackingsCarouselComponent() {
  const windowWidth = useWindowWidth()
  const windowHeight = useWindowHeight()
  // let orderTrackings = windowWidth <= 1500 ? trackings?.slice(0,6): trackings
  return (
    <div style={{ padding: "0px 20px", boxSizing:"border-box" }}>
      <div style={{ textAlign: "center", color: "white", marginBottom:"40px" }}>
        <h4 style={{ fontSize:  windowHeight <= 745 ? "20px" :windowWidth <=1500 ? "22px" :"30px" }}>Real-time tracking overview</h4>
        <h6 style={{ fontSize: windowHeight <= 745 ? "12px": windowWidth <=1500 ? "14px" : "16px"  }}>
          Continuously stay updated of trackings 
        </h6>
        <h6 style={{ fontSize: windowHeight <= 745 ? "12px": windowWidth <=1500 ? "14px" : "16px", marginBottom: windowHeight <= 745 ? "5px":"10px"  }}>
        of your shipments. Simply from one overview.
        </h6>
       
      </div>

      {trackings.map((tracking) => (
        <div
          key={tracking.id}
          className={styles.tracking_carousel_transition}
          style={{
            background: "#fff",
            borderRadius: "15px",
            padding: windowHeight <= 745 ? "5px 20px" : windowWidth <= 1500 ? "8px 20px" : "12px 20px",
            marginBottom: "12px",
          }}
        >
          <div className="flexbox">
            <h5 style={{ fontSize: windowHeight <= 745 ? "11px" : windowWidth <= 1500 ? "12px":"16px" }}>{generateStatusStyle(tracking.status)}</h5>
            <h5 style={{ fontSize:  windowHeight <= 745 ? "11px" : windowWidth <= 1500 ? "12px":"16px" }}>{tracking.text}</h5>
            <h5 style={{ fontSize:  windowHeight <= 745 ? "11px" : windowWidth <= 1500 ? "12px":"16px" }}>{tracking.days}</h5>
          </div>
        </div>
      ))}
    </div>
  );
}
